export default "__VITE_ASSET__Jkoyztio__"